import classNames from 'classnames';
import React, { memo } from 'react';
import { Icon, IconType } from '../icon/icon.component';
import { Text } from '../text/text.component';
import './menu.component.scss';

export declare namespace MenuType {
  type Props = {
    title?: string | null;
    className?: string | null;
    items: MenuType.Data.Item[];
    onNavigate?: (value: string) => void;
    selected?: string | string[] | null;
  };

  namespace Data {
    type Item = {
      key: string;
      label: string;
      params?: Record<string, string>;
      extra?: React.ReactNode;
      icon?: IconType.Props['variant'] | null;
      tooltip?: boolean;
      disabled?: boolean;
    };
  }
}

export const Menu = memo(
  ({
    className,
    items,
    selected,
    title,
    onNavigate = () => {},
  }: MenuType.Props) => {
    return (
      <div className={classNames('menu', className)}>
        {title && (
          <div className="menu__title">
            <Text
              color="deep_indigo_70"
              variant="label"
              textTransform="uppercase"
            >
              {title}
            </Text>
          </div>
        )}

        <div className="menu__items">
          {items.map((item, index) => {
            const isSelected = Array.isArray(selected)
              ? selected.includes(item.key)
              : selected === item.key;

            return (
              <div
                className={classNames('menu__items__item', {
                  'menu__items__item--selected': isSelected,
                  'menu__items__item--disabled': item.disabled,
                })}
                key={item.key}
                onClick={() => !item.disabled && onNavigate(item.key)}
              >
                <div className="menu__items__item__content">
                  {item.icon && (
                    <Icon
                      variant={item.icon}
                      color={isSelected ? 'white_100' : 'deep_indigo'}
                    />
                  )}
                  <Text
                    variant="headcaption"
                    color={isSelected ? 'deep_indigo_4' : 'deep_indigo'}
                  >
                    {item.label}
                  </Text>
                </div>
                {isSelected && (
                  <Icon variant={'arrow_right'} color="white_100" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);
